import { h, Component } from 'preact';
import { BaseComponent } from '../../common/BaseComponent';
import LinearProgress from 'preact-material-components/LinearProgress';
import Dialog from 'preact-material-components/Dialog';
import Button from 'preact-material-components/Button';
import { IModalDialogState, IModalDialogProps, IModalDialogOptions } from './IModalDialog';
import { bind } from 'decko';

import Snackbar from 'preact-material-components/Snackbar';
import { setTimeout } from 'timers';

let style = require('./style.scss');

export class ModalDialog extends BaseComponent<IModalDialogProps, IModalDialogState> {

    public refs: { dialog: Dialog, loader: Dialog, bar: Snackbar };

    private loaderAllowHide = true;
    private dialogAllowHide = true;

    constructor(props, ctx) {
        super(props, ctx);
        this.setState({
            options: {},
            loaderOptions: {}
        });
        window['mdcd'] = this; 
    }

    //public getState() {
    //    return this.state;
    //}

    //public setState(state: IModalDialogState) {
    //    this.setState(state);
    //}

    @bind
    public cleanModalAndDoAction(action: () => any): () => any {
        return () => { this.setState(s => { s.options.message = "" }); action(); }
    }

    @bind
    public alert(message: any, onAccpet?: () => any, title?: string, maxSize?: boolean) {
        this.showMessageBox({
            message: message,
            title: title,
            buttons: [{
                text: "OK",
                accept: true
            }],
            onAccpet: onAccpet,
            onCancel: onAccpet,
            maxSize: maxSize
        });
    }

    @bind
    public confirmation(message: any, onAccpet: () => any, acceptBtnText?: string, onCancel?: () => any, cancelBtnText?: string, title?: string, maxSize?: boolean) {
        this.showMessageBox({
            message: message,
            title: title,
            buttons: [{
                text: acceptBtnText || "OK",
                accept: true
            }, {
                text: cancelBtnText || "Cancel",
                cancel: true
            }],
            onAccpet: onAccpet,
            onCancel: onCancel,
            maxSize: maxSize
        });
    }

    @bind
    public showMessageBox(options: IModalDialogOptions) {
        options.message = this.fixMessage(options.message);
        this.setState({ options: { message: "" } });
        this.setState({ options: options });
        this.refs.dialog.MDComponent.show();
        this.dialogAllowHide = false;
        setTimeout(() => { this.dialogAllowHide = true; }, 300);
    }

    private fixMessage(message: any): any {
        if (typeof message === 'string') {
            message = message.replace("/\r\n/g", "\r");
            message = message.replace("/\n/g", "\r");
            var lines = (message as string).split("\r");
            message = <div>{lines.map(l => {
                l = l.trim();
                return l ? <div>{l}</div> : "";
            })}</div>;
        }
        return message;
    }

    @bind
    public showLoader<T>(promise: Promise<T>, title?: string): Promise<T> {
        var animation = this.loading(title);
        var oldMaxSize = this.state.options.maxSize;
        this.setState((s: IModalDialogState) => { s.options.maxSize = false; return s; });
        var prom = new Promise<T>((res, rej) => {
            animation.then(() => {
                promise.then((r) => {
                    this.refs.loader.MDComponent.close();
                    this.setState((s: IModalDialogState) => { s.options.maxSize = oldMaxSize; return s; });
                    res(r);
                }).catch((e) => {
                    this.refs.loader.MDComponent.close();
                    this.setState((s: IModalDialogState) => { s.options.maxSize = oldMaxSize; return s; });
                    rej(e);
                });
            });
        });
        return prom;
    }

    @bind
    public loading(title?: string) {
        if (!title)
            title = "Please wait...";
        var options: IModalDialogOptions = {
            loaderMessage: <LinearProgress indeterminate={true} />,
            loaderTitle: title
        }
        this.setState({ loaderOptions: options });
        this.refs.loader.MDComponent.show();
        this.loaderAllowHide = false;
        return new Promise((res, rej) => { setTimeout(() => { this.loaderAllowHide = true; res(); }, 300) });
    }

    @bind
    public hideLoader() {
        if (this.refs.loader.MDComponent.open) {
            if (this.loaderAllowHide) {
                this.refs.loader.MDComponent.close();
            }
            else {
                setTimeout(() => { this.hideLoader() }, 100);
            }
        }
    }

    @bind
    public hideDialog() {
        if (this.refs.dialog.MDComponent.open) {
            if (this.dialogAllowHide) {
                this.refs.dialog.MDComponent.close();
                this.setState((s: IModalDialogState) => { s.options = {}; return s; });
            }
            else {
                setTimeout(() => { this.hideDialog() }, 100);
            }
        }
    }

    @bind
    public showSnackBar(data: any) {
        this.refs.bar.MDComponent.show(data);
    }

    componentWillMount() {

    }

    componentDidMount() {

    }

    render() {

        return <div class={`${style.modalDialog} ${this.state.options.maxSize ? style.maxSize : ''}`}>
            <Dialog key={'alertDialog'} ref={this.setRef('dialog')} onAccept={this.state.options.onAccpet} onCancel={this.state.options.onCancel} >
                <Dialog.Header>{this.state.options.title}</Dialog.Header>
                <Dialog.Body>
                    {this.state.options.message}
                </Dialog.Body>
                <Dialog.Footer>
                    {this.state.options.buttons ? this.state.options.buttons.map(b => {
                        return <Dialog.FooterButton cancel={b.cancel} accept={b.accept} onClick={b.onClick}>{b.text}</Dialog.FooterButton>
                    }) : ("")}
                </Dialog.Footer>
            </Dialog>
            <Dialog key={'loaderDialog'} ref={this.setRef('loader')}>
                <Dialog.Header>{this.state.loaderOptions.loaderTitle}</Dialog.Header>
                <Dialog.Body>
                    {this.state.loaderOptions.loaderMessage}
                </Dialog.Body>
                <Dialog.Footer>
                    <Dialog.FooterButton class={style.hiddenButton} cancel={false} accept={false}></Dialog.FooterButton>
                </Dialog.Footer>
            </Dialog>
            <Snackbar ref={this.setRef('bar')} dismissesOnAction={true} />
        </div>;
    }
}



// WEBPACK FOOTER //
// ./components/modalDialog/modalDialog.tsx